import { useNavigate } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'

import { useI18n } from 'builder/hooks/useI18n'
import { useUser } from 'builder/hooks/useUser'
import { useTypedSelector } from 'builder/hooks/useTypedSelector'
import { useFeaturesConfig } from 'builder/hooks/featureConfig/useFeaturesConfig'
import useWebsiteHost from 'builder/components/CIO-Dasboard-2.0/hooks/useWebsiteHost'
import { useAutoApplyUpsellModal } from 'builder/components/AutoApplyUpsellModal/useAutoApplyUpsellModal'

import { selectors as profileSelectors } from 'builder/modules/careerProfile'

import {
  ActionButton,
  Container,
  Header,
  HeaderContainer,
  ImageContainer,
  SubHeader,
} from './styles'
import CoverImg from './assets/banner-cover.png'

const TRANSLATION = 'builder.dashboard.job_search_help.auto_apply.banner'

export const Banner = () => {
  const user = useUser()
  const { i18n } = useI18n()
  const navigate = useNavigate()
  const { getHost } = useWebsiteHost()
  const { features } = useFeaturesConfig()
  const { handleOpenModal } = useAutoApplyUpsellModal()
  const isAutoApplyComplete = useTypedSelector(profileSelectors.isAutoApplyComplete)

  const navigateTo = () => {
    trackInternalEvent('job_search_help_banner_click', {
      website_host: getHost,
      label: 'auto_apply',
    })

    if (features?.autoApply && !user?.scopes.autoApply) return handleOpenModal()
    navigate(isAutoApplyComplete ? '/job-search?view=recommendation' : '/auto-apply/start')
  }

  return (
    <Container>
      <HeaderContainer>
        <Header>{i18n.t(`${TRANSLATION}.header`)}</Header>
        <SubHeader>{i18n.t(`${TRANSLATION}.sub_header`)}</SubHeader>

        <ActionButton onClick={navigateTo}>{i18n.t(`${TRANSLATION}.action`)}</ActionButton>
      </HeaderContainer>
      <ImageContainer src={CoverImg} />
    </Container>
  )
}
